import { useSelector } from "react-redux"
import { Link, useLocation, useNavigate } from "react-router-dom";
import { useEffect, useState } from "react";
import { LoopServerCall, MetaTagHandler, ServerCallHandler, serverHtmlAttributes } from "../../library/client/serverCallHandler";
import NonLodable from "./nonLodable";
import NavBar from "./components/navbar";
import BeforeAfter from "./components/beforeAfter";
import StatsCard from "./components/statsCard";
import Services from "./components/services";
import Reviews from "./components/reviews";
import FAQ from "./components/faq";
import Contact from "./components/contact";
import Footer from "./components/footer";
import PageShell from "./components/pageShell";
import ZigZag from "./commercial/components/zigzag";
const AboutUs = () => {

    useEffect(() => {
        AOS.refresh();
    }, [])

    return (
        <>
            <MetaTagHandler>
                {() => (
                    <>
                        <title>About Us - Flyby Shine</title>
                        <meta name="description" content="As a service-disabled veteran-owned business, we lead in drone technology. Our FAA-licensed pilots deliver top-notch exterior cleaning services nationwide. We understand and meet our clients' specific needs, ensuring satisfaction guaranteed!" />
                        <meta name="keywords" content="About Us, Flyby Shine, Drone Technology, Exterior Cleaning Services, Nationwide Services, Satisfaction Guaranteed, Veteran Owned, FAA Licensed Pilots" />
                        <meta property="og:image" content="/assets/aboutus.png" />
                    </>
                )}
            </MetaTagHandler>

            <PageShell>

                <div className="short-hero">
                    <video autoPlay muted loop playsInline poster="/assets/videos/thumbnails/home.png">
                        <source src="/assets/videos/home.mp4" type="video/mp4" />
                    </video>
                    <h1 data-aos="fade-up" data-aos-delay="100">About Us</h1>
                </div>

                <div className="floating-text">
                    <div className="floating-bar"></div>
                    <p>As a service-disabled veteran-owned business, we lead in drone technology. Our FAA-licensed pilots deliver top-notch exterior cleaning services nationwide. We understand and meet our clients' specific needs, ensuring satisfaction guaranteed!</p>
                </div>

                <div className="duo-cards">
                    <div className="duo-card">
                        <img src="/assets/veteran.jpg" alt="about" style={{ filter: 'none' }} />
                        <h1>Veteran Owned</h1>
                        <p>As a proud service-disabled veteran-owned small business, we stand at the forefront of drone technology expertise.</p>
                    </div>
                    <div className="duo-card">
                        <img src="/assets/checkmark.svg" alt="about" />
                        <h1>FAA Licensed Pilots</h1>
                        <p>Our FAA-licensed pilots are trained to deliver top-notch exterior cleaning services nationwide.</p>
                    </div>
                </div>


                <ZigZag>
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/nationwide.png', alt: 'nationwide about us image' }}
                        title={'Operates Nationwide'}
                        heading={{ image: '/assets/nationwideIcon.svg', alt: 'operates nationwide' }}
                        description={'We proudly operate nationwide, delivering consistent and high-quality services across the entire country.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{ image: '/assets/drone2a.png', alt: 'drone displayed' }}
                        title={'Customized Approach'}
                        heading={{ image: '/assets/flexible.svg', alt: 'flexibility about us icon' }}
                        description={'Our drones offer the flexibility to adapt to various surfaces and architectural styles, whether it’s high-rise office buildings, complex industrial sites, or delicate historical structures.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            video: '/assets/videos/windowclean.mp4',

                        }}
                        title={'Advanced Drone Technology'}
                        heading={{ image: '/assets/water.svg', alt: 'water icon' }}
                        description={'Our advanced drone technology allows us to reach high areas safely and efficiently, providing a thorough cleaning solution for every window.'}
                    />
                    <ZigZag.Card
                        largeGraphic={{
                            image: '/assets/window.png',
                            alt: 'window cleaning'

                        }}
                        title={'More Cleaning Solutions'}
                        heading={{ image: '/assets/soap.svg', alt: 'soap and water icon' }}
                        description={'We offer a variety of cleaning solutions for your home or business. Our services include pressure washing, soft washing, window cleaning, and more.'}
                    />
                </ZigZag>


                <Contact />

            </PageShell>

            {/* <MetaTagHandler >
                {() => (
                    <>
                        <title>Poodle</title>
                    </>
                )}
            </MetaTagHandler>  */}
            {/* <NonLodable /> */}

            {/* <h2><ServerCallHandler id={"getDogHusky"} pathway={'getDog'} data={{breed:'husky'}} fetchHandler={'/api'} overwrite={'getDogHusky.src'} /></h2> */}



        </>
    )
}

export default AboutUs